<template>
  <div class="user-box elevation-2" style="position: relative;">
    <v-layout row wrap>
      <v-flex xs4 class="pb-0">
        <span><strong class="text-uppercase">{{ userName }} </strong><span v-if="userDocument == user.document">(VOCÊ)</span></span>
      </v-flex>
      <v-flex xs4 class="pb-0">
        <span>CPF: <strong>{{ userDocument }}</strong></span>
      </v-flex>
      <v-flex xs4 class="pb-0">
        <span><strong>{{ userRole | checkRole }}</strong></span>
      </v-flex>
      <v-flex xs6>
        <span>E-MAIL: <strong>{{ userEmail }}</strong></span>
      </v-flex>
      <v-flex xs6>
        <span>STATUS: <strong>{{ userStatus == 1 ? 'ATIVO' : 'INATIVO' }}</strong></span>
      </v-flex>
      <v-flex v-if="notAuthorized" @click="notAuthorized = false" xs12>
        <span class="red--text"><strong>VOCÊ NÃO PODE BLOQUEAR SEU PRÓPRIO USUÁRIO!</strong></span>
      </v-flex>
      <v-flex v-if="errorActive" @click="errorActive = false" xs12>
        <span class="red--text"><strong>ERRO AO EXECUTAR ALTERAÇÃO, TENTE NOVAMENTE!</strong></span>
      </v-flex>
      <span class="ban-button" @click="changeStatus()"><i class="fas fa-ban"></i></span>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['user-name', 'user-document', 'user-email', 'user-status', 'user-role', 'user-id'],
  data() {
    return {
      notAuthorized: false,
      errorActive: false
    }
  },
  methods: {
    changeStatus() {
      if (this.userId != this.user.id) {
        this.$http.put(`users/active/${this.userId}/${this.userStatus == 1 ? 0 : 1}`, {}).then(data => {
          this.$emit('getUsers')
        }).catch(err => {
          this.errorActive = true
        })
      } else {
        this.notAuthorized = true
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
}
</script>

<style scoped>
  .user-box {
    border-left: solid 10px #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    margin-bottom: 26px;
    cursor: pointer;
  }
  .ban-button {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .ban-button:hover {
    color: #c4161c;
  }
</style>
